<template>
    <div id="firthree">
        <div class="firthree_bg">
            <p class="p-36">平台可以通过以下方式为您提供版权相关服务</p>
            <img src="../../img/copyrightService.png" class="top_img" />
        </div>
        <div class="firthree_conent">
            <p class="p-30">专业、高效、省时、安全</p>
            <button class="jump_link" @click="govipPersonal()">购买产品</button>
                <ul class="firthree_ul">
                    <li>
                        <img src="../../img/zy.png" />
                        <p class="ul-p20">专业</p>
                        <p class="ul-p12">系统充分运用了区块链不可篡改的技术特性，客观记录作品的版权信息，利用大数据和人工智能技术，对比准确率可达95%以上</p>
                    </li>
                    <li>
                        <img src="../../img/gx.png" />
                        <p class="ul-p20">高效</p>
                        <p class="ul-p12">对比库全面覆盖国内主流库，24小时不间断更新</p>
                    </li>
                    <li>
                        <img src="../../img/ss.png" />
                        <p class="ul-p20">省时</p>
                        <p class="ul-p12">使用大数据支撑的智能算法，进行盗版监测和侵权取证；灵活运用智能合约机制，实现自动化的交易匹配</p>
                    </li>
                    <li style="margin-right:0px">
                        <img src="../../img/aq.png" />
                        <p class="ul-p20">安全</p>
                        <p class="ul-p12">及时排查侵权风险，提高风险防范能力。降低侵权事件发生的概率，减少侵权赔偿损失</p>
                    </li>
                </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name:'firthree',
        data(){
            return {

            }
        },
        methods:{
            govipPersonal(){
                // window.open('/vipPersonal','_blank')
              this.$router.push({ path:'/goods',query: null })
            }
        }
    }
</script>

<style scoped lang="less">
    .jump_link{
      width:160px;
      height:44px;
      background:rgba(255,255,255,1);
      box-shadow:1px 2px 0px 1px rgba(232,46,49,0.1);
      border:1px solid rgba(232,46,49,1);
      font-size:16px;
      font-weight:400;
      color:rgba(232,46,49,1);
      line-height:24px;
      cursor: pointer;
      outline: none;
      margin-top:27px;
    }
    #firthree{
        width: 100%;
        background: #FFFFFF;
        .firthree_bg{
            width: 100%;
            height: 520px;
            background:url('./../../img/bg1.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .p-36{
                width:760px;
                height:36px;
                font-size:36px;
                font-weight:bold;
                color:rgba(255,255,255,1);
                line-height:54px;
                letter-spacing:2px;
                margin: 0 auto;
                margin-top: 118px;
            }
            img{
                margin-top:-20px;
            }
        }
        .firthree_conent{
            width:1334px;
            height:426px;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
            margin:0 auto;
            margin-top: -276px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .p-30{
                width:353px;
                height:30px;
                font-size:30px;
                font-weight:300;
                color:rgba(18,18,16,1);
                line-height:45px;
                letter-spacing:1px;
                margin-top:56px;
            }
            button{
                width:160px;
                height:44px;
                background:rgba(255,255,255,1);
                box-shadow:1px 2px 0px 1px rgba(232,46,49,0.1);
                border:1px solid rgba(232,46,49,1);
                font-size:16px;
                font-weight:400;
                color:rgba(232,46,49,1);
                margin-top:33px;
            }
            .firthree_ul{
                margin-top: 37px;
                display: flex;
                justify-content: stretch;
                li{
                    float: left;
                    width:239px;
                    height: 200px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    margin-right: 76px;
                    img{
                        width:21px;
                        height: 21px;
                    }
                    .ul-p20{
                        font-size:20px;
                        font-weight:bold;
                        color:#121210;
                        letter-spacing:2px;
                        margin:15px 0;
                    }
                    .ul-p12{
                        font-size:12px;
                        font-weight:400;
                        color:#666666;
                        line-height: 24px;
                    }
                }
            }
        }
    }
</style>